import { Pipe, PipeTransform } from '@angular/core';
import { toFormControlValidator } from './draft-validator';

@Pipe({
    name: 'toValidator',
    standalone: false
})
export class ValidatorPipe implements PipeTransform {
    transform(validationInfo: any, options?: any) {
        if (validationInfo?.validations) {
            return toFormControlValidator(validationInfo, options);
        }

        return null;
    }
}
